import { lightAnimation } from "@/scenes/MyFirstScene";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    route: "",
    spinnerLoading: true,
    currentLab: null,
    currentItem: null,
  },
  getters: {
    getRoute: (state) => state.route,
    isSpinnerLoading: (state) => state.spinnerLoading,
    getCurrentLab: (state) => state.currentLab,
    getCurrentItem: (state) => state.currentItem,
  },
  mutations: {
    setRoute: (state, route) => {
      state.route = route;
    },
    setSpinnerLoading: (state, payload) => {
      state.spinnerLoading = payload;
    },
    setLab: (state, lab) => {
      state.currentLab = lab;
    },
    setItem: (state, item) => {
      state.currentItem = item;
    },
  },
  actions: {
    setSpinner: ({ commit }, { loading, spinner = false }) => {
      if (spinner) {
        commit("setSpinnerLoading", loading);
      } else {
        return lightAnimation(!loading);
      }
    },
  },
});
